// The one place that reads what the bundler injected.
//
// Every other module in this package takes its configuration as an argument, so
// that a check can drive it over inputs it chooses rather than over whatever
// this build happens to hold. That rule is what makes environment.ts and
// notices.ts testable at all, and it needs exactly one file to break it —
// otherwise `import.meta.env` appears in a component and the component becomes
// untestable without a bundler.
//
// BRACKET ACCESS, THE SAME SHAPE AS xp/console/src/build/thisBuild.ts, AND NOT
// A DEFENSIVE READ OF THE WHOLE OBJECT. On 2026-08-30 this file asked whether
// import.meta carried an env property and then read that object. Vite inlines
// import.meta.env["VITE_XP_ENV"] as the string "staging". It does not rewrite a
// membership test against the native import.meta, which has no such key in a
// browser. The built bundle therefore contained {VITE_XP_ENV:"staging"} as an
// unused object, the page took the empty fallback, and a scanned QR code said
// the environment was not set. verify-build.mjs treated the unused object as
// proof the value was inlined. Both are fixed: this file reads the keys the
// bundler actually replaces, and verify-build looks for the resulting string
// in the position that means "this is the environment this build is for".

export const BUILD = {
  /** VITE_XP_ENV. vite.config.ts refuses a build that does not resolve. */
  environment: import.meta.env["VITE_XP_ENV"] as string | undefined,

  /**
   * Who the parties are, for the notices.
   *
   * Staging names Blackpeak in web/package.json. Production is typed through
   * scripts/vite-build.mjs for Nova's own test show (nova_is_controller)
   * until TASKS §138 answers the controller question for a client.
   * readNoticeConfig refuses to produce a privacy notice until all three
   * are present. Deliberately not defaulted here.
   */
  notices: {
    clientName: import.meta.env["VITE_XP_CLIENT_NAME"] as string | undefined,
    controller: import.meta.env["VITE_XP_CONTROLLER"] as
      | "client_is_controller"
      | "nova_is_controller"
      | "joint_controllers"
      | undefined,
    contactAddress: import.meta.env["VITE_XP_CONTACT_ADDRESS"] as string | undefined,
  },
} as const;
